var exports = {
  "badge": "xf0b3b88a--90a0a0--badge",
};

module.exports = exports;
